import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { WaterfallTemplate, ClassicTemplate, CategoryBtns } from '../index'
import { menuMobx, restaurantConfig } from 'restaurant'
import './index.scss'

interface IProps {
}

const ProductTemplate: FC<IProps> = () => {
  const products = menuMobx.products.filter(item => menuMobx.isOpenSoldout ? item.saleCnt !== 0 : true)
  return (
    <div className='product-template'>
      {
        restaurantConfig.displayMode === 'waterfall' ? (
          <>
            <WaterfallTemplate products={products} selectCategoryNo={menuMobx.selectCategoryNo} />
            {/* 底部分类btns */}
            <CategoryBtns />
          </>
        ) : <ClassicTemplate />
      }
    </div>
  )
}

export default observer(ProductTemplate)
